import { render } from "./HappyHourItem.vue?vue&type=template&id=685af9b2"
import script from "./HappyHourItem.vue?vue&type=script&lang=js"
export * from "./HappyHourItem.vue?vue&type=script&lang=js"
script.render = render

export default script